import * as React from 'react';
import styled from 'styled-components';
import { Text, Spacer } from '../parts';
import { Footer } from './parts/Footer';

export const Privacy: React.FC = () => {
	return (
		<PageBody>
			<Container>
				<Spacer size={60} />
				<Text weight="black" size={50} center>
					Privacy & Policy
				</Text>
				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						1. Introduction
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						Live Rewards ("we" or "us" or "our") operates the website. This page informs you of our policies regarding the collection, use, and disclosure of personal data when you
						use our service and the choices you have associated with that data.
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						2. Information Collection and Use
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						We collect several different types of information for various purposes to provide and improve our service to you.
						<br />
						<br />
						<strong>Personal Data:</strong>
						<br />
						• Email address
						<br />
						• First name and last name
						<br />
						• Phone number
						<br />
						• Address, State, Province, ZIP/Postal code, City
						<br />• Cookies and Usage Data
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						3. Use of Data
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						Live Rewards uses the collected data for various purposes:
						<br />
						• To provide and maintain our service
						<br />
						• To notify you about changes to our service
						<br />
						• To allow you to participate in interactive features of our service
						<br />
						• To provide customer support
						<br />
						• To gather analysis or valuable information so that we can improve our service
						<br />
						• To monitor the usage of our service
						<br />• To detect, prevent and address technical issues
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						4. Security of Data
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we
						strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						5. Contact Us
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						If you have any questions about this Privacy Policy, please contact us at privacy@liverewardsgo.com
					</Text>
				</ContentSection>

				<Spacer size={100} />
			</Container>
			<Footer />
		</PageBody>
	);
};

const PageBody = styled.div``;

const Container = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0px 20px;

	@media only screen and (max-width: 1200px) {
		padding: 0px 20px;
	}
`;

const ContentSection = styled.div`
	max-width: 800px;
	width: 100%;
`;
